import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_REVIEW_CONTRACTORS_WITH_CONTENT_TYPES } from "../services/get-review-contractors-with-content-types";

const initialState = {
  reviewContractorsList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_REVIEW_CONTRACTORS_WITH_CONTENT_TYPES)(action)) {
        return { ...state, reviewContractorsList: [] };
      }
      if (isAsyncComplete(GET_REVIEW_CONTRACTORS_WITH_CONTENT_TYPES)(action)) {
        const response = action.response;
        return { ...state, reviewContractorsList: response };
      }
      return state;
    default:
      return state;
  }
}
